/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RecordRead } from "../../models/record-read";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadTemplateRecord$Params {
  template_record_id: number;
  organisation_id: string;
  template_id: number;
}

export function readTemplateRecord(
  http: HttpClient,
  rootUrl: string,
  params: ReadTemplateRecord$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RecordRead>> {
  const rb = new RequestBuilder(rootUrl, readTemplateRecord.PATH, "get");
  if (params) {
    rb.path("template_record_id", params.template_record_id, {});
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("template_id", params.template_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecordRead>;
    }),
  );
}

readTemplateRecord.PATH =
  "/surfdomeinen/organisations/{organisation_id}/templates/{template_id}/records/{template_record_id}";
